import React from 'react'

interface AISparklesIconProps {
  color?: string
  colorVar?: string
  width?: string | number
  height?: string | number
  marginTop?: string | number
  marginRight?: string | number
  marginBottom?: string | number
  marginLeft?: string | number
  paddingTop?: string | number
  paddingRight?: string | number
  paddingBottom?: string | number
  paddingLeft?: string | number
}

const AISparklesIcon = ({
  color,
  colorVar,
  width = 14,
  height = 14,
  marginTop,
  marginRight,
  marginBottom,
  marginLeft,
  paddingTop,
  paddingRight,
  paddingBottom,
  paddingLeft,
}: AISparklesIconProps) => (
  <svg
    width={width}
    height={height}
    style={{
      marginTop,
      marginRight,
      marginBottom,
      marginLeft,
      paddingTop,
      paddingRight,
      paddingBottom,
      paddingLeft,
    }}
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="ai-sparkles-icon"
  >
    <path
      d="M9.10938 3.59375L10.75 4.25L11.4062 5.89062C11.4609 5.97266 11.543 6 11.625 6C11.707 6 11.7617 5.97266 11.8164 5.89062L12.5 4.25L14.1133 3.59375C14.1953 3.53906 14.25 3.45703 14.25 3.375C14.25 3.29297 14.1953 3.23828 14.1133 3.18359L12.5 2.5L11.8164 0.886719C11.7617 0.804688 11.707 0.75 11.625 0.75C11.543 0.75 11.4609 0.804688 11.4062 0.886719L10.75 2.5L9.10938 3.18359C9.02734 3.23828 9 3.29297 9 3.375C9 3.45703 9.02734 3.53906 9.10938 3.59375ZM14.1133 11.9336L12.5 11.25L11.8164 9.63672C11.7617 9.55469 11.707 9.5 11.625 9.5C11.543 9.5 11.4609 9.55469 11.4062 9.63672L10.75 11.25L9.10938 11.9336C9.02734 11.9883 9 12.043 9 12.125C9 12.207 9.02734 12.2891 9.10938 12.3438L10.75 13L11.4062 14.6406C11.4609 14.7227 11.543 14.75 11.625 14.75C11.707 14.75 11.7617 14.7227 11.8164 14.6406L12.5 13L14.1133 12.3438C14.1953 12.2891 14.25 12.207 14.25 12.125C14.25 12.043 14.1953 11.9883 14.1133 11.9336ZM10.75 7.75C10.75 7.58594 10.6406 7.42188 10.5039 7.36719L7.41406 5.80859L5.88281 2.74609C5.71875 2.44531 5.25391 2.44531 5.08984 2.74609L3.55859 5.80859L0.46875 7.36719C0.332031 7.42188 0.25 7.58594 0.25 7.75C0.25 7.91406 0.332031 8.07812 0.46875 8.13281L3.55859 9.69141L5.08984 12.7812C5.17188 12.918 5.30859 13 5.5 13C5.63672 13 5.80078 12.918 5.88281 12.7812L7.41406 9.69141L10.5039 8.13281C10.6406 8.07812 10.75 7.91406 10.75 7.75Z"
      fill={colorVar ? `var(${colorVar})` : color || '#B987D9'}
    />
  </svg>
)

export default AISparklesIcon
